import { useNavigate } from 'react-router-dom'

/**
 * Nút quay lại. <b>Mọi màn hình đều dùng đúng cái này</b>, không màn nào tự vẽ lại.
 *
 * To và có chữ, không phải một mũi tên bé xíu. Người dùng của app này 45–60 tuổi, bấm
 * bằng ngón cái trên màn hình cảm ứng ở quán thiếu sáng — một cái mũi tên 20px là thứ họ
 * bấm trượt ba lần rồi thôi, và khi đã không tìm được đường về thì họ tắt app đi.
 *
 * Ba thứ phải giống nhau ở mọi màn hình, và đó là lý do nút này là một thành phần chung
 * chứ không phải một đoạn mã chép qua chép lại:
 *
 *   1. <b>Cùng một chỗ</b> — góc trên bên trái, ô đầu tiên của hàng tiêu đề. Bấm mãi
 *      thành quen tay, mắt không cần tìm.
 *   2. <b>Cùng một màu</b>, và là màu <b>đậm nhất màn hình</b>. Mọi nút khác nhạt hơn,
 *      nên trong một màn hình đầy thẻ trắng thì mắt bắt được nó ngay.
 *   3. Cùng chiều cao 56px như mọi nút chính khác trong app.
 */

interface Props {
  /** Đường quay về. Màn hình nào cần làm việc khác trước khi rời đi thì truyền `onBack`. */
  to?: string
  onBack?: () => void
  label?: string
}

export function PageBack({ to, onBack, label = 'Quay lại' }: Props) {
  const nav = useNavigate()

  return (
    <button
      type="button"
      className="page-back"
      onClick={onBack ?? (() => nav(to ?? '/'))}
      aria-label={label}
    >
      <span className="page-back-arrow" aria-hidden="true">
        ‹
      </span>
      <span className="page-back-text">{label}</span>
    </button>
  )
}
